import authService from './authService';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

class MfaService {
  async getMfaStatus() {
    try {
      const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/mfa/status`);

      if (!response.ok) {
        throw new Error(`Failed to load MFA status: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error getting MFA status:', error);
      throw error;
    }
  }

  async getMfaMethods() {
    try {
      const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/mfa/methods`);

      if (!response.ok) {
        throw new Error(`Failed to load MFA methods: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error getting MFA methods:', error);
      throw error;
    }
  }

  async setupAuthenticatorApp(deviceName) {
    try {
      const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/mfa/authenticator/setup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ deviceName })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(error.message || 'Failed to setup authenticator app');
      }

      return await response.json();
    } catch (error) {
      console.error('Error setting up authenticator app:', error);
      throw error;
    }
  }

  async verifyAuthenticatorApp(secret, code, deviceName) {
    try {
      const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/mfa/authenticator/verify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ secret, code, deviceName })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(error.message || 'Failed to verify authenticator app');
      }

      return await response.json();
    } catch (error) {
      console.error('Error verifying authenticator app:', error);
      throw error;
    }
  }

  async setupSms(phoneNumber, deviceName) {
    try {
      const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/mfa/sms/setup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ phoneNumber, deviceName })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(error.message || 'Failed to setup SMS method');
      }

      return await response.json();
    } catch (error) {
      console.error('Error setting up SMS:', error);
      throw error;
    }
  }

  async removeMfaMethod(methodId) {
    try {
      const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/mfa/methods/${methodId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(error.message || 'Failed to remove MFA method');
      }

      return await response.json();
    } catch (error) {
      console.error('Error removing MFA method:', error);
      throw error;
    }
  }

  async setPrimaryMethod(methodId) {
    try {
      const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/mfa/methods/${methodId}/primary`, {
        method: 'POST',
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(error.message || 'Failed to set primary method');
      }

      return await response.json();
    } catch (error) {
      console.error('Error setting primary method:', error);
      throw error;
    }
  }

  async generateRecoveryCodes(count = 10) {
    try {
      const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/mfa/recovery-codes/generate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ count })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(error.message || 'Failed to generate recovery codes');
      }

      return await response.json();
    } catch (error) {
      console.error('Error generating recovery codes:', error);
      throw error;
    }
  }

  async verifyMfaCode(code) {
    try {
      const response = await authService.authenticatedFetch(`${API_BASE_URL}/api/mfa/verify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({ message: response.statusText }));
        throw new Error(error.message || 'Failed to verify MFA code');
      }

      return await response.json();
    } catch (error) {
      console.error('Error verifying MFA code:', error);
      throw error;
    }
  }
}

const mfaServiceInstance = new MfaService();
export default mfaServiceInstance;

